<template>
  <UProgress
    v-bind="{ ...$attrs, ...props }"
    :model-value="modelValue"
    :get-value-label="
      typeof $attrs['aria-label'] === 'string'
        ? () => String($attrs['aria-label'])
        : props.getValueLabel
    "
    class="p-progress"
    @update:model-value="onValueUpdate"
    @update:max="emit('update:max', $event)"
  >
    <template v-for="(_, name) in slots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps" />
    </template>
  </UProgress>
</template>

<script setup lang="ts">
import type { ComponentColor } from "@/config/component-colors"
import type { VNode } from "vue"
import UProgress, { type ProgressProps } from "@nuxt/ui/components/Progress.vue"

type ProgressColor = ComponentColor

interface Props extends Omit<ProgressProps, "modelValue" | "color" | "ui"> {
  color?: ProgressColor
}

const props = defineProps<Props>()
const modelValue = defineModel<number | null>({ default: null })
const emit = defineEmits<{ "update:max": [value: number] }>()
const slots = defineSlots<{
  [name: string]: (props: { percent?: number; step?: unknown }) => VNode[]
}>()
defineOptions({ inheritAttrs: false })

function onValueUpdate(value: unknown) {
  if (typeof value === "number" || value === null) modelValue.value = value
}
</script>
